import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useNuxtApp } from '#app'
import { useSyncData } from '@/composables/useSyncData'
import { useAuthStore } from '@/stores/useAuthStore'
import type { Tax } from '@/_api/models/tax'

export const useTaxStore = defineStore('tax', () => {
  const { $api, $grants } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<Tax>({
    service: $api.tax,
    key: 'tax',
    accountId,
    grants: { tax: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if (!$grants.all({ tax: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const all = computed(() => items.value)
  const syncDate = computed(() => syncState.value.date)

  return {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
  }
})
